class ContractorAuthService {
  constructor() {
    // Use local API for development, production API for production
    const isLocalDev = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
    this.baseUrl = isLocalDev 
      ? 'https://localhost:7080/api'
      : 'https://xero-payment-api-cmb-c0epbxffhccgdsbs.canadacentral-01.azurewebsites.net/api';
  }

  async apiCall(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`;
    const token = this.getToken();
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers
      },
      ...options
    };

    try {
      console.log('🔐 Contractor API Call:', options.method || 'GET', endpoint);
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('❌ Contractor API Error:', error);
      throw error;
    }
  }

  async validateInvite(token) {
    return await this.apiCall(`/contractor/validate-invite/${token}`);
  }

  async register(registrationData) {
    return await this.apiCall('/contractor/register', {
      method: 'POST',
      body: JSON.stringify(registrationData)
    });
  }

  async login(loginData) {
    return await this.apiCall('/contractor/login', {
      method: 'POST',
      body: JSON.stringify(loginData)
    });
  }

  async validateToken() {
    try {
      await this.apiCall('/contractor/dashboard');
      return true;
    } catch (error) {
      return false;
    }
  }

  getToken() {
    return localStorage.getItem('contractorToken');
  }

  getUser() {
    const userStr = localStorage.getItem('contractorUser');
    return userStr ? JSON.parse(userStr) : null;
  }

  clearToken() {
    localStorage.removeItem('contractorToken');
    localStorage.removeItem('contractorUser');
  }
}

export default new ContractorAuthService();
